import { FE_PREFETCH_SIGNUP_IFRAME_250328 } from "@faire/retailer-settings/FE_PREFETCH_SIGNUP_IFRAME_250328";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingPrefetchSignUpIframe = () => {
  return useSetting(FE_PREFETCH_SIGNUP_IFRAME_250328);
};
